<template>
  <div class="result">
    <img
      src="https://picbed.qunarzz.com/bce85a248a31efc407663b828146a8b3.png"
      alt=""
    />
    <div v-if="!ranking" class="result-box">
      <img
        class="result-head"
        :src="ownInfo.headImg"
        alt=""
      />
      <div class="result-title">{{this.ownInfo.nickName}}</div>
      <div class="result-title">您答对了{{ currectCommit }}道题</div>
      <div class="label">得分：{{this.ownInfo.point}}</div>
    </div>
    <div v-if="ranking" class="ranking">
      <div class="ranking-head">
        <div class="ranking-tit label">总排名</div>
      </div>
      <div class="ranking-box">
          <div class="ranking-head">
              <div class="ranking-head-box">
                <span>名次</span>
                <span class="rt">总分</span>
                <span class="nick">昵称</span>
              </div>
          </div>
          <div class="ranking-content">
            <div v-for="(item,index) in rankList" :key="index" class="ranking-item label2" :class="{active:index==0}">
              <span>{{item.rank}}</span>
              <span class="rt">{{item.totalPoint}}</span>
              <span class="nick text-overflow">{{item.nickName}}</span>
            </div>
          </div>
          <div class="label totalPoint">
              我的总分:{{this.totalPoint}}
          </div>
      </div>
    </div>
    <div class="result-buttons" :class="{ rankingType: ranking }">
      <div @click="again" class="startAnswer label2">
        {{ ranking ? "再玩一次" : "再玩一次" }}
      </div>
      <p v-if="ranking" class="remainTimes label2">剩余{{ remainTimes }}次机会</p>
      <div @click="lookMyRank" v-if="!ranking" class="startAnswer label2">查看排名</div>
    </div>
  </div>
</template>

<script>
import loginDialog from "../dialog/login/index";
import {shareToPlatform} from '@/utils/hybird'
// import share from './dialog/share/index'
import createAudio from './audio'
export default {
  props: ["currectCommit"],
  data() {
    return {
      questions: [],
      remainTimes:0,
      headImg:'',
      ownInfo:{
        
      },
      rankList:[],
      totalPoint:0,
      ranking: false,
    };
  },
  methods: {
    destoryFn(){
      if (hysdk.sniff.scheme) {
        location.href = hysdk.sniff.scheme + `://home`
      } else {
        location.href = 'https://www.qunar.com/'
      }
    },
    again() {
      if(this.remainTimes==0){
        this.$dialog.alert({
            message: '今日答题次数已用完',
        });
        return;
      }
      this.$emit("again");
    },
    returnHome(){
      this.$emit("again");
    },
    shareToPlatform(){
      shareToPlatform(()=>{
        this.getMoreTimes();
      },()=>{
        share();
        this.getMoreTimes();
        /* error函数，暂时没有用 */
      }); 
    },
    lookMyRank2(){
      createAudio('totalReward');
      this.lookMyRank();
    },
    lookMyRank() {
      // createAudio('totalReward');
      // myRanking({
      //   ownInfo:this.ownInfo,
      //   callback:()=>{
      //       this.toprank();
      //       this.ranking = true;
      //   }
      // });
      this.toprank();
      this.ranking = true;
    },
    getMoreTimes(){
      this.$axios.post('/union/guessing/addtimes').then((res)=>{
          if(res.code==400){
              loginDialog({
                callback: () => {
                  this.getMoreTimes();
                },
              });
          }else if(res.code == 200){
              // this.$dialog.alert({
              //     message: '分享成功',
              // });
              this.getRemainTimes();
          }else{
              // this.$dialog.alert({
              //     message: res.message,
              // });
          }
      })
    },
    toprank(){
      this.$axios.get("/union/guessing/toprank").then((res) => {
        if (res.code == 400) {
          loginDialog({
            callback: () => {
              this.toprank();
            },
          });
        } else if (res.code == 200) {
          this.rankList = res.data;
          this.$axios.get("/union/guessing/point").then((res) => {
            if (res.code == 200) {
              this.totalPoint = res.data.allPoint;
            } else {
              this.$dialog.alert({
                message: res.message,
              });
            }
          });
        } else {
          this.$dialog.alert({
            message: res.message,
          });
        }
      });
    },
    getRemainTimes(){
      this.$axios.post('/union/guessing/remaintimes',{}).then((res)=>{
            if(res.code==400){
                loginDialog({
                  callback: () => {
                    this.getRemainTimes();
                  },
                });
            }else if(res.code == 200){
                this.remainTimes = res.data.remaintimes;
            }else{
                this.$dialog.alert({
                    message: res.message,
                });
            }
        })
    },
    myOwnInfo(showRanking,topicRecordId) {
      this.ranking = showRanking || false;
      if(topicRecordId){
          this.$axios.get("/union/guessing/once/point?topicRecordId="+topicRecordId).then((res) => {
            if (res.code == 400) {
              loginDialog({
                callback: () => {
                  this.myOwnInfo(showRanking,topicRecordId);
                },
              });
            } else if (res.code == 200) {
              this.ownInfo = res.data;
              this.$axios.get("/union/guessing/headshot").then((res) => {
                if(res.code == 200) {
                  this.$set(this.ownInfo,'headImg',res.data);
                } else {
                  this.$dialog.alert({
                    message: res.message,
                  });
                }
              });
            } else {
              this.$dialog.alert({
                message: res.message,
              });
            }
          });
      } 
      
    },
  }
};
</script>

<style lang="less" scoped="true">
.label{
  color: #F5ED20;
  margin-top:27px;
  font-size:23px;
  text-shadow: 2px 0 0 #000,-2px 0 0 #000,0 -2px 0 #000,0 2px 0 #000;
  font-weight: bold;
}
.label2{
  color:#fff;
  text-shadow: 2px 0 0 #000,-2px 0 0 #000,0 -2px 0 #000,0 2px 0 #000;
  font-weight: bold;
}
.startAnswer {
  width: 179px;
  height: 53px;
  font-size: 25px;
  text-align: center;
  line-height: 53px;
  background: url(https://picbed.qunarzz.com/635c01bb3054e6eb7241ac1c357d5c12.png) no-repeat;
  background-size: 100% auto;
  border-radius: 7px;
  position: absolute;
  left: 50%;
  margin-left: -90px;
  top: 524px;
  font-weight: normal;
  color: #fff;
  line-height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  top:0;
  .label{
    text-shadow: 2px 0 0 #000,-2px 0 0 #000,0 -2px 0 #000,0 2px 0 #000;
    font-weight: bold;
    position: relative;
    top:-2px;
  }
}
.totalPoint{
  margin-top:0 !important;
  position: relative;
  top:20px;
}
.remainTimes{
  position: absolute;
  right:0;
  top:-48px;
  background:url(https://picbed.qunarzz.com/a8f8734eddd09f86d5c73b4ce1af6db8.png) no-repeat;
  background-size:100% auto;
  width:76px;
  height:34px;
  line-height:28px;
  font-size:11px;
  color:#FFC000 !important;
}
.result {
  position: relative;
  &-box {
    position: absolute;
    left: 50%;
    top: 209px;
    margin-left: -142px;
    width: 285px;
    min-height: 326px;
    border-radius: 3px;
  }
  &-head {
    width: 73px;
    height: 73px;
    border-radius: 50%;
    margin-top: 26px;
  }
  &-title {
    font-size: 25px;
    color: #05C0E8;
    margin-top: 12px;
  }
  &-submit {
    width: 257px;
    height: 46px;
    border-radius: 23px;
    color: #5885cf;
    text-align: center;
    line-height: 46px;
    font-size: 17px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 8px;
  }
  &-des {
    color: #fff;
    margin-top: 12px;
  }
  &-buttons {
    width: 198px;
    position: absolute;
    top: 520px;
    left: 50%;
    margin-left: -99px;
    .button {
      width: 198px;
      height: 53px;
      background: #5885cf;
      box-shadow: 0px 3px 4px 0px rgba(97, 142, 213, 0.58);
      border-radius: 7px;
      text-align: center;
      line-height: 53px;
      font-size: 25px;
      color: #fff;
      font-style: italic;
      position: relative;
      .tag {
        width: 46px;
        position: absolute;
        right: 0;
        top: -20px;
      }
    }
    p {
      color: #5885cf;
      font-size: 12px;
      margin-top: 11px;
      margin-bottom: 11px;
    }
  }
}
.ranking {
  position: absolute;
  left: 50%;
  top: 209px;
  margin-left: -142px;
  width: 285px;
  height: 313px;
  &-tit {
    font-size: 25px;
    color: #F5ED20;
    margin-bottom:14px;
    margin-top:14px;
  }
  &-head{
    &-box{
      padding-top:12px;
      padding-bottom:8px;
      font-size:11px;
      color:#C5FCFE;
      &:before,&:after{
        content:"";
        display: block;
        clear: both;
      }
      span{
        float: left;
        width:25%;
        text-align: center;
        &:last-child{
          width: 50%;
        }
      }
    }
  }
  &-box {
    height: 142px;
    width:253px;
    margin-left:auto;
    margin-right: auto;
    background: #0BA3EA;
    box-shadow: inset 0px 1px 9px 2px rgba(11, 137, 234, 0.71);
    border-radius: 3px;
    padding-bottom: 10px;
    box-sizing: border-box;
  }
  &-content{
    height:100px;
    overflow-y: auto;
  }
  &-item {
    width: 100%;
    border-radius: 23px;
    color: #fff;
    font-size: 20px;
    text-align: center;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    .nick {
      padding-left: 16px;
      padding-right:16px;
      -webkit-line-clamp:1;
    }
    &:before,&:after{
      content:"";
      display: block;
      clear: both;
    }
    span{
      box-sizing: border-box;
      flex:1;
      float: left;
      width:25%;
      height: 24px;
      line-height: 24px;
      margin-top:4px;
      margin-bottom:4px;
      &:last-child{
        width: 50%;
      }
    }
  }
  &-head{
    span{

    }
  }
}
.disabled {
  background: #8694aa !important;
  box-shadow: 0px 3px 4px 0px rgba(97, 142, 213, 0.58) !important;
  border-radius: 7px !important;
}
.lookRank{
  position: absolute;
  width:72px;
  right:0;
  top:80px;
}
.moreTimes{
  position: absolute;
  width:24px;
  left:12px;
  bottom:80px;
  z-index:1;
}
</style>